import customerService from "../services/customer.service";

const customers = {
    namespaced: true,
    state: {
        debitOrderDates: null,
        consentSmsStatuses: null,
        bankAccountTypes: null,
        importChanges: null, // New state property to store import changes

    },
    actions: {
        //CREATE
        async customerimport({ commit }, formData) {
            try {
                const changes = await customerService.customerimport(formData);
                commit("setImportChanges", changes);
                return changes; 
            } catch (error) {
                
                throw new Error("Failed to import customers,please review the data in the import file ");
            }
        },

        create(_, formData) {
            return customerService.create(formData);
        },
        sendcustomersms(_, parameters)
        {
            return customerService.sendcustomersms(parameters);
        },

        sendcustomercardsms(_, parameters)
        {
            return customerService.sendcustomercardsms(parameters.customerId, parameters.companyId);
        },

        addNote(_, params) {
            return customerService.addNote(params.customerId, params.text);
        },
        sendconsentsms(_, params) {
            return customerService.sendconsentsms(params.customerId);
        },

        sendwelcomesmsesforcompanycustomers(_, params) {
            return customerService.sendwelcomesmsesforcompanycustomers(params);
        },
        sendconsentsmsesforcompanycustomers(_, params) {
            return customerService.sendconsentsmsesforcompanycustomers(params);
        },

        sendcardsmsesforcompanycustomers(_, params) {
            return customerService.sendcardsmsesforcompanycustomers(params);
        },

        downloadmedicallegalconsentdocument(_, params) {
            return customerService.downloadmedicallegalconsentdocument(params);
        },

        //READ
        get(_, params) {
            return customerService.get(params.id, params.urlParameters, params.requestId);
        },

        getCustomerStatusesCompany() {
            return customerService.getCustomerStatusesCompany();
        },
        getCustomerStatusesIndividual() {
            return customerService.getCustomerStatusesIndividual();
        },

        async getDebitOrderDates({ commit, state, getters }) {

            if (state.debitOrderDates === null) {
                var response = await customerService.getDebitOrderDates();
                commit("setDebitOrderDates", response.data);
            }
            return getters.debitOrderDates;

        },

        async getConsentSmsStatuses({ commit, state, getters }) {
            if (state.consentSmsStatuses === null) {
                var response = await customerService.getConsentSmsStatuses();
                commit("setConsentSmsStatuses", response.data);
            }
            return getters.consentSmsStatuses;
        },

       //  getConsentSmsStatuses() {
        //        return customerService.getConsentSmsStatuses();
        //},
        getAccisureDashboard() {
            return customerService.getAccisureDashboard();
        },

        comissionreport(_, params) {
            return customerService.comissionReport(params.fromDate, params.toDate);
        },
        customerlogreport(_, params) {
            return customerService.customerLogReport(params);
        },

        sendwelcomeemail(_, id) {
            return customerService.sendwelcomeEmail(id);
        },
        sendwelcomesms(_, params) {
            return customerService.sendwelcomeSms(params.customerId);
        },

        async getbankaccounttypes({ commit, state, getters }) {
            if (state.bankAccountTypes === null) {
                var response = await customerService.getbankaccounttypes();
                commit("setBankAccountTypes", response);
            }
            return getters.bankAccountTypes;
        },
        
    

        //UPDATE
        update(_, params) {
            return customerService.update(params.id, params.formData);
        },

        adddependant(_, params) {
            return customerService.addDependant(params.customerId, params.dependantIdentityId);
        },

        removedependant(_, params) {
            return customerService.removeDependant(params.customerId, params.dependantIdentityId);
        },

        //DELETE
        delete(_, id) {
            return customerService.delete(id);
        },
    },
        
    
    getters: {
        debitOrderDates: (state) => state.debitOrderDates,
        bankAccountTypes: (state) => state.bankAccountTypes,
        consentSmsStatuses: (state) => state.consentSmsStatuses
    },
    mutations: {
        setDebitOrderDates(state, types) {
            state.debitOrderDates = types;
        },
        setBankAccountTypes(state, types) {
            state.bankAccountTypes = types;
        },
        setConsentSmsStatuses(state, types) {
            state.consentSmsStatuses = types;
        },
// Update mutation type to include namespace: customers/setImportChanges
        setImportChanges(state, changes) {
            state.importChanges = changes;
        },

    },
};

export default customers;
